import { BoxType } from 'components/Box'
import Section, { SectionType, Size } from 'components/Section/Section'
import React from 'react'
import { connect } from 'react-redux'
import { AppState } from 'src/data/state'
import { EntryProps } from '../../../data/entries/types'
import { Theme } from '../../../data/models/funnelOrder/theme'
import FunnelFooter from '../../../elements/footers/funnelFooter'
import GiftcardModal from '../../../elements/modals/GiftcardModal'
import { getNameWithTheme, getParamsWithTheme } from '../../../routing/links'
import DisplayContent from '../../shared/content'
import Page from '../../shared/page_wrapper'
import BasicInfo from '../components/basicInfo'
import HowItWorks from '../components/entries/howItWorks'
import FAQ from '../components/faq'
import { FoodLoversBookNow } from './FoodLoversBookNow'
import FoodLoversDetails from './FoodLoversDetails'
import { FoodLoversFlavourBox } from './FoodLoversFlavourBox'
import { FoodLoversHero } from './FoodLoversHero'

interface BucketListProps extends EntryProps {
  total: number
}

const FoodLoversPage: React.FC<BucketListProps> = ({ match, entry, total }) => {
  const detailsRef: React.RefObject<HTMLDivElement> = React.createRef()
  const infoRef: React.RefObject<HTMLDivElement> = React.createRef()

  if (entry.page === undefined) {
    throw new Error('No page properties')
  }

  const handleDetailsScroll = () => {
    detailsRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const handleInfoScroll = () => {
    infoRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const isNextStepDisabled = () => {
    return !total || isNaN(total)
  }

  return (
    <Page
      match={match}
      page={entry.page.name}
      color={entry.colour}
      navBarType="funnel"
      navBarOverrideColour={
        entry.page?.style ? entry.page.style.navbarColor : undefined
      }
      navFooter
      whiteBackground
    >
      <FoodLoversHero entry={entry} />
      <BasicInfo
        type={SectionType.transparentWhite}
        nrItems={4}
        detailsScroll={handleDetailsScroll}
        infoScroll={handleInfoScroll}
      />
      <Section type={SectionType.white} size={Size.m} noBottomPadding>
        <div ref={detailsRef} />
        {/* @ts-ignore */ }
        <FoodLoversDetails entry={entry} />
      </Section>
      <GiftcardModal />
      <FunnelFooter
        nextStepNo={2}
        nextStepLink={getNameWithTheme('extras')}
        nextStepLinkParams={getParamsWithTheme()}
        nextStepName={
          <DisplayContent edit={true} contentKey="extras">
            Extras
          </DisplayContent>
        }
        stickyStop
        nextStepDisabled={isNextStepDisabled()}
      />
      <div ref={infoRef} />
      <FoodLoversFlavourBox
        content={entry.page.content}
        numberOfItemsLeft={
          entry.page.params.theme === Theme.foodLoversFly ? 6 : 5
        }
        numberOfItemsRight={6}
      />
      <HowItWorks
        backgroundImageLink={'bucketlist-heading-bg.jpg'}
        boxTypeColor={BoxType.tomatoHeaders}
      />
      <FoodLoversBookNow onClick={handleDetailsScroll} />
      <FAQ size={Size.m} />
    </Page>
  )
}

const mapStateToProps = (state: AppState) => ({
  total: state.funnelOrder.total,
})

export default connect(mapStateToProps)(FoodLoversPage)
